// js libraries
import moment from "moment";
import axios from "axios";
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";

Fancybox.Plugins.Toolbar.defaults.items.close.html = "<span></span>";

// custom js code
import sanitizeTitle from "./custom/sanitize-title.js";
import serialize from "./custom/serialize.js";

// vue directives
import LazyLoadDirective from './vue/directives/lazy-load-directive.js'
import OutsideClickDirective from './vue/directives/outside-click-directive.js'

// vue components
import ResponsiveImage from './vue/components/_responsive-image.vue';
import ResponsiveConcreteImage from './vue/components/_responsive-concrete-image.vue';
import TravelListItem from './vue/components/_travel-list-item.vue';
import TravelTileItem from './vue/components/_travel-tile-item.vue';

window.axios = require('axios');
window.moment = require('moment');
require('moment/locale/de-ch.js');
moment.locale('de-ch');
Vue.prototype.sanitizeTitle = sanitizeTitle;
Vue.prototype.serialize = serialize;
Vue.component('responsive-image', ResponsiveImage);
Vue.component('responsive-concrete-image', ResponsiveConcreteImage);
Vue.directive('lazyload', LazyLoadDirective);